import { AMCF_TAB_MESSAGE_TAB_CLAIM, AMCF_TAB_MESSAGE_TAB_SUPERSEDED } from './amcf-tab-coordinator.constants';
import type { AmcfTabMessage } from './amcf-tab-coordinator.models';

/** UUID v4 generato da `crypto.randomUUID()` nelle tab legittime. */
const TAB_ID_UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Tolleranza clock skew per `openedAt`. */
export const AMCF_TAB_OPENED_AT_CLOCK_SKEW_MS = 60_000;

export function isValidTabId(tabId: string): boolean {
  return tabId.length > 0 && tabId.length <= 36 && TAB_ID_UUID_V4_REGEX.test(tabId);
}

export function isValidOpenedAt(openedAt: number, now = Date.now()): boolean {
  return Number.isFinite(openedAt) && openedAt > 0 && openedAt <= now + AMCF_TAB_OPENED_AT_CLOCK_SKEW_MS;
}

/**
 * Valida e normalizza un messaggio BroadcastChannel in ingresso.
 * Restituisce `null` per payload malformati, tipi sconosciuti o valori fuori range.
 */
export function parseTabMessage(data: unknown, now = Date.now()): AmcfTabMessage | null {
  if (!data || typeof data !== 'object') {
    return null;
  }
  const msg = data as Record<string, unknown>;

  if (msg['type'] === AMCF_TAB_MESSAGE_TAB_CLAIM) {
    const tabId = msg['tabId'];
    const openedAt = msg['openedAt'];
    if (typeof tabId !== 'string' || typeof openedAt !== 'number') {
      return null;
    }
    if (!isValidTabId(tabId) || !isValidOpenedAt(openedAt, now)) {
      return null;
    }
    return {
      type: AMCF_TAB_MESSAGE_TAB_CLAIM,
      tabId,
      openedAt
    };
  }

  if (msg['type'] === AMCF_TAB_MESSAGE_TAB_SUPERSEDED) {
    const winnerTabId = msg['winnerTabId'];
    const winnerOpenedAt = msg['winnerOpenedAt'];
    if (typeof winnerTabId !== 'string' || typeof winnerOpenedAt !== 'number') {
      return null;
    }
    if (!isValidTabId(winnerTabId) || !isValidOpenedAt(winnerOpenedAt, now)) {
      return null;
    }
    return {
      type: AMCF_TAB_MESSAGE_TAB_SUPERSEDED,
      winnerTabId,
      winnerOpenedAt
    };
  }

  return null;
}
